import { render, staticRenderFns } from "./CveNameAndLinkTableCell.vue?vue&type=template&id=32f3c689&scoped=true"
import script from "./CveNameAndLinkTableCell.vue?vue&type=script&lang=js"
export * from "./CveNameAndLinkTableCell.vue?vue&type=script&lang=js"
import style0 from "./CveNameAndLinkTableCell.vue?vue&type=style&index=0&id=32f3c689&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f3c689",
  null
  
)

export default component.exports